import * as React from 'react';
import { useState } from 'react';
import {
    useListContext,
    useRefresh,
    useNotify,
    useUnselectAll,
    useResourceContext,
    useTranslate,
    Confirm,
} from 'react-admin';
import Button from '@mui/material/Button';
import ReportProblemIcon from '@mui/icons-material/ReportProblemOutlined';

// Bulk-force user_data_state to "stale" for the selected users via POST /user/stale/force.
// Shared endpoint/component across teacher/student/pupil - the underlying flag/logic is
// identical regardless of role (unlike invitation resend, which is teacher-specific).
const BulkForceStaleButton = () => {
    const { selectedIds } = useListContext();
    const resource = useResourceContext();
    const refresh = useRefresh();
    const notify = useNotify();
    const translate = useTranslate();
    const unselectAll = useUnselectAll(resource);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        setConfirmOpen(false);
        try {
            const res = await fetch(
                `${process.env.REACT_APP_INFRA_API}/user/stale/force`,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                    body: JSON.stringify({ guids: selectedIds }),
                }
            );
            if (!res.ok) throw new Error('force stale failed');
            const data = await res.json();
            notify(
                translate('resources.user.stale.bulk_result', {
                    updated: data.updated ?? 0,
                    requested: data.requested ?? 0,
                }),
                { type: 'info' }
            );
            unselectAll();
            refresh();
        } catch (e) {
            notify(translate('resources.user.stale.bulk_error'), {
                type: 'error',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                color="warning"
                size="small"
                startIcon={<ReportProblemIcon />}
                disabled={loading}
                onClick={() => setConfirmOpen(true)}
            >
                {translate('resources.user.stale.bulk_force')}
            </Button>
            <Confirm
                isOpen={confirmOpen}
                loading={loading}
                title={translate('resources.user.stale.bulk_confirm_title')}
                content={translate(
                    'resources.user.stale.bulk_confirm_content',
                    {
                        count: selectedIds.length,
                    }
                )}
                onConfirm={handleConfirm}
                onClose={() => setConfirmOpen(false)}
            />
        </>
    );
};

export default BulkForceStaleButton;
